import { PromotionCard } from "@repo/components";
import { getNumberOfGridColumnsMd } from "@repo/lib/helpers";
const Promotions = ({
  data
}) => {
  const {
    Card
  } = data;
  if (!Card?.length) return null;
  const columnCount = Math.min(Card.length, 3);
  return <section className="mx-auto px-4 py-10 md:max-w-screen-xl md:px-0" data-sentry-component="Promotions" data-sentry-source-file="Promotions.jsx">
      <div className={`${getNumberOfGridColumnsMd(columnCount)} grid grid-cols-1 gap-5`}>
        {Card?.map(item => <PromotionCard key={item?.id} item={item} />)}
      </div>
    </section>;
};
export default Promotions;